var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.75C8.02537 0.75 0.75 8.02537 0.75 17C0.75 25.9746 8.02537 33.25 17 33.25C25.9746 33.25 33.25 25.9746 33.25 17C33.25 8.02537 25.9746 0.75 17 0.75ZM24.1339 17.8839C24.3683 17.6495 24.5 17.3315 24.5 17C24.5 16.6685 24.3683 16.3505 24.1339 16.1161L19.1339 11.1161C18.6457 10.628 17.8543 10.628 17.3661 11.1161C16.878 11.6043 16.878 12.3957 17.3661 12.8839L20.2322 15.75L10.75 15.75C10.0596 15.75 9.5 16.3096 9.5 17C9.5 17.6904 10.0596 18.25 10.75 18.25L20.2322 18.25L17.3661 21.1161C16.878 21.6043 16.878 22.3957 17.3661 22.8839C17.8543 23.372 18.6457 23.372 19.1339 22.8839L24.1339 17.8839Z",
    fill: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowArrow);
export default __webpack_public_path__ + "static/media/yellow-arrow.4a84eae94c69ee6c1bdead6ea8a80b21.svg";
export { ForwardRef as ReactComponent };